import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./src/styles/global.css"
import "./src/styles/flags.css"
import "./src/styles/carousel.css"
import "./src/styles/menu.css"
import "./src/styles/download-popup.css"
import "./src/styles/slot-game-popup.css"
import "./src/styles/bookmark-popup.css"
import "./src/styles/switch.css"
import "./src/styles/text-input.css"
import "./src/styles/slots-cards.css"
import "./src/styles/simple-text.css"
import "./src/styles/slot-page.css"
import "./src/styles/cards.css"
import "./src/styles/slot-info.css"
import "./src/styles/slot-info-tabs.css"
import "./src/styles/blog.css"
import "./src/components/ZoomableImage/styles.css"
import "./src/components/SmartBanner/styles.css"
import "./src/styles/blog.css"
import "./static/fonts/style.css"
import "./src/styles/lp-pages.css"

import "./src/styles/index.scss"


export const onInitialClientRender = () => {
    document.querySelectorAll("script").forEach((script) => {
      if (!script.hasAttribute("data-ot-ignore")) {
        script.setAttribute("data-ot-ignore", "true");
      }
    });
  };